export default {
	state: {
		token: ''
	},
	mutations: {
		set_token(state, token) {
			state.token = token
			localStorage.token = token
		},
		del_token(state) {
			state.token = ''
			localStorage.removeItem('token')
		},
		get_token(state){
			console.log(state)
			//state.token=state.token || localStorage.getItem('token');
			console.log('我被调用了')
			
		}
	}
}
